import React from 'react';
import { HaulierDetailsStepper } from 'src/component/haulier-sign-up/haulier-details-stepper';

export const HaulierSingUpStepScreen = (): React.ReactElement => {
	return <HaulierDetailsStepper />;
};
